module.exports = __webpack_public_path__ + "static/media/eerikkila-logo.6ad21a1b.svg";